import type { ImageItem, Unit } from '../types';

SvgSection.$inject = ['$resource'];

interface HouseUnitsResponse {
  success: boolean;
  message: string;
  sections: {
    [key: string]: {
      images: {
        bitmap: ImageItem[];
        svg: ImageItem[];
      };
      units: Unit[];
    };
  };
}

export interface SvgSectionResource {
  getUnits: (
    params: {
      id: string | number;
    },
    success?: (resp: { [key: string]: Unit }) => any,
    error?: (error: any) => any,
  ) => angular.resource.IResource<{ [key: string]: Unit }>;
  getHouseUnitsBySection: (
    params: {
      id: string | number;
    },
    success?: (resp: HouseUnitsResponse) => any,
    error?: (error: any) => any,
  ) => angular.resource.IResource<HouseUnitsResponse>;
}

export function SvgSection(
  $resource: angular.resource.IResourceService,
): SvgSectionResource {
  return $resource(
    '/api/',
    {},
    {
      getUnits: {
        method: 'GET',
        url: '/api/v1/unit/section/:id/asObject',
        isArray: false,
      },
      getHouseUnitsBySection: {
        method: 'GET',
        url: '/api/v1/unit/house/:id/asObject',
        isArray: false,
        // important because we may issue the same request multiple times
        // we want them all to be merged to one actual network request
        cache: true,
      },
    },
  ) as any;
}
